/*
 * ============================
 * File: index.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:11:05 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Saturday, 18th April 2020 9:32:52 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

// Imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import authenticate from '@/auth/authenticate'
import { findPermissionsForRoute } from '../data/userRoles'
import { items } from '../data/navigationThree'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/views/app/Index'),
      beforeEnter: authenticate,
      redirect: '/app/dashboard/home',

      children: [
        // {
        //   path: "layout/:layout",
        //   component: () => import("@/views/app/Index")
        // },
        {
          path: '/app/dashboard',
          component: () => import('@/views/app/dashboard/Index'),

          children: [
            {
              path: 'home',
              name: 'home',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'home' }],
              },
              component: () => import('@/views/app/dashboard/Home'),
            },
            {
              path: 'handheld',
              name: 'handheld',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'handheld' }],
              },
              component: () => import('@/views/app/dashboard/handheld'),
            },
            {
              path: 'alerts',
              name: 'alerts',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'alerts' }],
              },
              component: () => import('@/views/app/dashboard/alerts'),
            },
            {
              path: 'AlertsSite/:id',
              name: 'AlertsSite/:id',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'alerts' }],
              },
              props: { default: true },
              component: () => import('@/views/app/dashboard/AlertsSite'),
            },
          ],
        },
        {
          path: '/app/changeorder',
          component: () => import('@/views/app/admin/Index.vue'),
          children: [
            {
              name: 'order',
              path: 'order/:id',
              props: { default: true },
              component: () => import('@/views/app/changeorder/ChangeOrder'),
            },
            {
              path: 'changeordermanagement',
              name: 'changeordermanagement',
              component: () => import('@/views/app/changeorder/ChangeOrderManagement'),
            },
            {
              path: 'changeorderprofiles',
              name: 'changeorderprofiles',
              component: () => import('@/views/app/changeorder/ChangeOrderProfiles'),
            },
            {
              path: 'changeordersettings',
              name: 'changeordersettings',
              component: () => import('@/views/app/changeorder/ChangeOrderSettings'),
            },
            {
              path: 'changeordershipment',
              name: 'changeordershipment',
              component: () => import('@/views/app/changeorder/ChangeOrderShipment'),
            },
            {
              name: 'changeorderadmin',
              path: 'changeorderadmin',
              component: () => import('@/views/app/changeorder/ChangeOrderAdmin'),
            },
            {
              name: 'paythingssiteqr',
              path: 'paythingssiteqr',
              component: () => import('@/views/app/changeorder/PaythingsSiteQR'),
            },
          ],
        },
        // {
        //   path: '/app/changeorder',
        //   component: () => import('@/views/app/admin/Index.vue'),
        //   children: [
        //     {
        //       path: 'changeorder',
        //       name: 'changeorder',
        //       component: () => import('@/views/app/changeorder/ChangeOrder'),
        //     },
        //     {
        //       path: 'changeordermanagement',
        //       name: 'changeordermanagement',
        //       component: () => import('@/views/app/changeorder/ChangeOrderManagement'),
        //     },
        //     {
        //       path: 'changeorderprofiles',
        //       name: 'changeorderprofiles',
        //       component: () => import('@/views/app/changeorder/ChangeOrderProfiles'),
        //     },
        //     {
        //       path: 'changeordersettings',
        //       name: 'changeordersettings',
        //       component: () => import('@/views/app/changeorder/ChangeOrderSettings'),
        //     },
        //     {
        //       path: 'changeordershipment',
        //       name: 'changeordershipment',
        //       component: () => import('@/views/app/changeorder/ChangeOrderShipment'),
        //     },
        //   ],
        // },
        {
          path: '/app/reports/',
          component: () => import('@/views/app/reports/Index.vue'),
          children: [
            {
              path: 'reports',
              name: 'reports',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'reports' }],
              },
              component: () => import('@/views/app/reports/Reports'),
            },
            {
              path: '/ReportLive/:id',
              name: '/reportlive/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportLive'),
            },
            {
              name: 'ReportLive2',
              path: '/reportlive2/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportLive2'),
            },
            {
              name: 'ReportMonth',
              path: '/reportmonth/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportMonth'),
            },
            {
              name: 'ReportTransit',
              path: '/reporttransit/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportTransit'),
            },
            {
              name: 'ReportCashin',
              path: '/reportcashin/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportCashin'),
            },
            // {
            //   name: 'ReportMonth',
            //   path: '/reportmonth/:id',
            //   props: { default: true },
            //   component: () => import('@/views/app/reports/ReportMonth'),
            // },
            {
              name: 'ReportDeposit',
              path: '/reportdeposit/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportDeposit'),
            },
            {
              path: 'reportsgroup',
              name: 'reportsgroup',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroup'),
            },
            {
              name: 'ReportsGroupPickups',
              path: 'ReportsGroupPickups/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroupPickups'),
            },
            {
              name: 'ReportsGroupUserEod',
              path: 'ReportsGroupUserEod/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroupUserEod'),
            },
            {
              name: 'ReportsGroupCashin',
              path: 'reportsgroupcashin/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroupCashin'),
            },
            {
              name: 'ReportsGroupShipments',
              path: 'reportsgroupshipments/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroupShipments'),
            },
            {
              name: 'ReportsGroupCit',
              path: 'reportsgroupcit/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsGroupCit'),
            },
            {
              path: 'reportsdevices',
              name: 'reportsdevices',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportsDevices'),
            },
            {
              path: 'reportnotereader/:id',
              name: 'reportnotereader/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportNotereader'),
            },
            {
              name: 'ReportVersions/:id',
              path: 'reportversions/:id',
              props: { default: true },
              component: () => import('@/views/app/reports/ReportVersions'),
            },
          ],
        },
        {
          path: '/app/deposits/',
          component: () => import('@/views/app/deposits/Index.vue'),
          children: [
            {
              path: 'depositactions',
              name: 'depositactions',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'depositactions' }],
              },
              component: () => import('@/views/app/deposits/Depositactions'),
            },
            {
              path: 'postalactions',
              name: 'postalactions',
              props: { default: true },
              component: () => import('@/views/app/deposits/Postalactions'),
            },
            {
              name: 'Deposit Users',
              path: 'Depositusers/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/Deposituserspersite'),
            },
            {
              name: 'Deposits In Transit',
              path: 'Deposittransit/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/Deposittransit'),
            },
            {
              name: 'DTS Deposits',
              path: 'Depositslip/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/Depositslip'),
            },
            {
              name: 'Post Deposits',
              path: 'Depositpost/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/Depositpost'),
            },
            {
              name: 'Depositshipments',
              path: 'Depositshipments/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/Depositshipments'),
            },
            {
              name: 'Track Shipments',
              path: 'Deposittracking/:id',
              props: { default: true },
              component: () => import('@/views/app/deposits/DepositTracking'),
            },
          ],
        },
        {
          path: '/app/EstateManagement',
          component: () => import('@/views/app/admin/Index.vue'),
          children: [
            {
              path: 'sitemanagement',
              name: 'sitemanagement',
              component: () => import('@/views/app/EstateManagement/SiteManagement'),
            },
            {
              name: 'paythingssecurityactions',
              path: 'paythingssecurityactions',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/PaythingsSecurityActions'),
            },
            {
              name: 'Deposit Keys',
              path: 'Depositkeys/:id',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/DepositKeyspersite'),
            },
            {
              name: 'paythingspickupactions',
              path: 'paythingspickupactions',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/PaythingsPickupActions'),
            },
            {
              name: 'PickupSchedule',
              path: 'PickupSchedule/:id',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/PickupSchedule'),
            },
            {
              name: 'PickupReports',
              path: 'PickupReports/:id',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/PickupReports'),
            },
            {
              name: 'MLManagement',
              path: 'MLManagement',
              component: () => import('@/views/app/EstateManagement/MLManagement'),
            },
            {
              name: 'MLSite',
              path: 'MLSite/:id',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/MLSite'),
            },
            {
              name: 'MLSiteNotes',
              path: 'MLSiteNotes/:id',
              props: { default: true },
              component: () => import('@/views/app/EstateManagement/MLSiteNotes'),
            },
          ],
        },
        {
          path: '/app/PackageVerification',
          component: () => import('@/views/app/PackageVerification/Index.vue'),
          children: [
            {
              path: 'PackageVerification',
              name: 'PackageVerification',
              component: () => import('@/views/app/PackageVerification/PostalPackageReceipt'),
            },
            {
              name: 'PostalPackageValidation',
              path: 'PostalPackageValidation',
              props: { default: true },
              component: () => import('@/views/app/PackageVerification/PostalPackageValidation'),
            },
          ],
        },
        {
          path: '/app/PostalManagement',
          component: () => import('@/views/app/postal/Index.vue'),
          children: [
            {
              name: 'Postaldashboard',
              path: 'Postaldashboard',
              component: () => import('@/views/app/postal/PostalDashboard'),
            },
            {
              name: 'PostalVerifyManagement',
              path: 'PostalVerifyManagement',
              component: () => import('@/views/app/postal/PostalVerifyManagement'),
            },
          ],
        },
        {
          path: '/app/accounting',
          component: () => import('@/views/app/accounting/Index.vue'),
          children: [
            {
              name: 'PaythingsBillingsGroups',
              path: 'PaythingsBillingsGroups',
              component: () => import('@/views/app/accounting/PaythingsBillingGroups'),
            },
            {
              name: 'PaythingsReportsInvoices',
              path: 'paythingsreportsinvoices',
              component: () => import('@/views/app/accounting/PaythingsReportsInvoices'),
            },
            {
              name: 'PaythingsClientInvoices',
              path: 'Paythingsclientinvoices',
              component: () => import('@/views/app/accounting/PaythingsClientInvoices'),
            },
            {
              name: 'PaythingsBillingInfo',
              path: 'PaythingsBillingInfo',
              component: () => import('@/views/app/accounting/PaythingsBillingInfo'),
            },
            {
              name: 'PaythingsBillingRates',
              path: 'PaythingsBillingRates',
              component: () => import('@/views/app/accounting/PaythingsBillingRates'),
            },
            {
              name: 'PaythingsBillingClients',
              path: 'PaythingsBillingClients',
              component: () => import('@/views/app/accounting/PaythingsBillingClients'),
            },
            // {
            //   name: 'PaythingsReportsInvoices',
            //   path: 'paythingsreportsinvoices',
            //   component: () => import('@/views/app/accounting/PaythingsReportsInvoices'),
            // },
          ],
        },
        {
          path: '/app/Namsys',
          component: () => import('@/views/app/Namsys/Index.vue'),
          children: [
            {
              name: 'NamsysConfig',
              path: 'NamsysConfig',
              component: () => import('@/views/app/Namsys/NamsysConfig'),
            },
            {
              name: 'NamsysDailyFeed',
              path: 'NamsysDailyFeed',
              component: () => import('@/views/app/Namsys/NamsysDailyFeed'),
            },
            {
              name: 'NamsysLookup',
              path: 'NamsysLookup/:origin/:id',
              props: { default: true },
              component: () => import('@/views/app/Namsys/NamsysLookup'),
            },
            {
              name: 'NamsysTransactions',
              path: 'NamsysTransactions',
              props: { default: true },
              component: () => import('@/views/app/Namsys/NamsysTransactions'),
            },
          ],
        },
        {
          path: '/app/Kapcharge',
          component: () => import('@/views/app/Kapcharge/Index.vue'),
          children: [
            {
              name: 'Config',
              path: 'KapchargeConfig',
              component: () => import('@/views/app/Kapcharge/KapchargeConfig'),
            },
            {
              name: 'KapchargeDailyFeed',
              path: 'KapchargeDailyFeed',
              component: () => import('@/views/app/Kapcharge/KapchargeDailyFeed'),
            },
            
          ],
        },
        {
          path: '/app/V5_Feed',
          component: () => import('@/views/app/V5_Feed/Index.vue'),
          children: [
            {
              name: 'V5DailyFeed',
              path: 'V5DailyFeed',
              component: () => import('@/views/app/V5_Feed/V5DailyFeed'),
            },
            {
              name: 'V5SequenceAdmin',
              path: 'V5SequenceAdmin',
              component: () => import('@/views/app/V5_Feed/V5SequenceAdmin'),
            },
            {
              name: 'V5SequencePublished',
              path: 'V5SequencePublished',
              component: () => import('@/views/app/V5_Feed/V5SequencePublished'),
            },
            
          ],
        },
        {
          path: '/app/safeandsound',
          component: () => import('@/views/app/safeandsound/Index.vue'),
          children: [

            {
              name: 'ssConfig',
              path: 'ssConfig',
              component: () => import('@/views/app/safeandsound/ssConfig'),
            },
            {
              name: 'ssDailyFeed',
              path: 'ssDailyFeed',
              component: () => import('@/views/app/safeandsound/ssDailyFeed'),
            },
            
          ],
        },
        {
          path: '/app/Kapcharge',
          component: () => import('@/views/app/Kapcharge/Index.vue'),
          children: [
            {
              name: 'kapchargecashlevels',
              path: 'kapchargecashlevels',
              component: () => import('@/views/app/Kapcharge/KapchargeCashLevels'),
            },
            {
              name: 'KapchargeConfig',
              path: 'KapchargeConfig',
              component: () => import('@/views/app/Kapcharge/KapchargeConfig'),
            },
            {
              name: 'KapchargeReportsEOD',
              path: 'KapchargeReportsEOD',
              component: () => import('@/views/app/Kapcharge/KapchargeReportsEOD'),
            },
            {
              name: 'KapchargeReportsCIT',
              path: 'KapchargeReportsCIT',
              component: () => import('@/views/app/Kapcharge/KapchargeReportsCit'),
            },
            {
              name: 'KapchargeDailyFeed',
              path: 'KapchargeDailyFeed',
              component: () => import('@/views/app/Kapcharge/KapchargeDailyFeed'),
            },
            
          ],
        },
        {
          path: '/app/CashConnect',
          component: () => import('@/views/app/CashConnect/Index.vue'),
          children: [
            {
              name: 'ccreportscashlevels',
              path: 'ccreportscashlevels',
              component: () => import('@/views/app/CashConnect/CCReportsCashLevels'),
            },
            {
              name: 'CC Daily Files',
              path: 'CCDailyFiles/:id',
              props: { default: true },
              component: () => import('@/views/app/CashConnect/CCDailyFiles'),
            },
            {
              name: 'CC Change Orders',
              path: 'CCChangeOrders/:id',
              props: { default: true },
              component: () => import('@/views/app/CashConnect/CCChangeOrders'),
            },
            {
              name: 'CCCit',
              path: 'CCCit/:id',
              props: { default: true },
              component: () => import('@/views/app/CashConnect/CCCit'),
            },
            {
              name: 'CCTransfers',
              path: 'CCTransfers/:id',
              props: { default: true },
              component: () => import('@/views/app/CashConnect/CCTransfers'),
            },
            {
              name: 'CCLive',
              path: 'CCLive/:id',
              props: { default: true },
              component: () => import('@/views/app/CashConnect/CCLive'),
            },
            {
              name: 'CCEstateConfig',
              path: 'CCEstateConfig',
              component: () => import('@/views/app/CashConnect/CCEstateConfig'),
            },
            {
              name: 'CCSiteReports',
              path: 'CCSiteReports',
              component: () => import('@/views/app/CashConnect/CCSiteReports'),
            },
            {
              name: 'cashconnectconfig',
              path: 'cashconnectconfig',
              component: () => import('@/views/app/CashConnect/PaythingsCashConnectConfig'),
            },
            {
              name: 'CCReportsOperationsGroup',
              path: 'CCReportsOperationsGroup',
              component: () => import('@/views/app/CashConnect/CCReportsOperationsGroup'),
            },
          ],
        },
        {
          path: '/app/FI',
          component: () => import('@/views/app/postal/Index.vue'),
          children: [
            {
              name: 'FIchangeorderadmin',
              path: 'FIChangeOrderAdmin',
              component: () => import('@/views/app/FI/FIChangeOrderAdmin'),
            },
            {
              name: 'Fieodreports',
              path: 'Fieodreports',
              component: () => import('@/views/app/FI/FIReportEod'),
            },
            {
              name: 'FIActions',
              path: 'FIActions',
              component: () => import('@/views/app/FI/FIActions'),
            },
            // {
            //   name: 'FiUnitStatus',
            //   path: 'FiUnitStatus/:id',
            //   props: { default: true },
            //   component: () => import('@/views/app/FI/FiUnitStatus'),
            // },
            {
              name: 'Fieod',
              path: 'Fieod/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/Fieod'),
            },
            {
              name: 'FiDepositUsers',
              path: 'FiDepositUsers/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/FiDepositUsers'),
            },
            {
              name: 'FI Deposit Admin',
              path: 'Depositusers/:instid/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/Deposituserspersite'),
            },
            {
              name: 'Ficit',
              path: 'Ficit/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/Ficit'),
            },
            {
              name: 'Fipredictions',
              path: 'Fipredictions/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/Fipredictions'),
            },
            {
              name: 'FISiteAnalysis',
              path: 'FISiteAnalysis/:instid/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/FISiteAnalysis'),
            },
            {
              name: 'FICITAnalysis',
              path: 'FICITAnalysis/:instid/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/FICITAnalysis'),
            },
            {
              name: 'Fiai',
              path: 'Fiai/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/Fiai'),
            },
            {
              name: 'FiAiEod',
              path: 'FiAiEod/:instid/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/FiAiEod'),
            },
            {
              name: 'FiAiNotes',
              path: 'FiAiNotes/:instid/:id',
              props: { default: true },
              component: () => import('@/views/app/FI/FiAiNotes'),
            },
          ],
        },
        {
          path: '/app/admin',
          component: () => import('@/views/app/admin/Index.vue'),
          children: [
            {
              path: 'usermanagement',
              name: 'usermanagement',
              component: () => import('@/views/app/admin/UserManagement'),
            },
            {
              path: 'VaultAIMiami',
              name: 'VaultAIMiami',
              component: () => import('@/views/app/admin/VaultAIMiami'),
            },
            {
              path: 'simulator',
              name: 'simulator',
              component: () => import('@/views/app/admin/Simulator'),
            },
            {
              name: "FormWizardAddSmartSafeSite",
              path: "FormWizardAddSmartSafeSite",
              component: () =>
                import("@/views/app/admin/FormWizardAddSmartSafeSite"),
            },
            {
              name: "FormWizardAddVirtualSite",
              path: "FormWizardAddVirtualSite",
              component: () =>
                import("@/views/app/admin/FormWizardAddVirtualSite"),
            },
            {
              name: "FormWizardAddPostalSite",
              path: "FormWizardAddPostalSite",
              component: () =>
                import("@/views/app/admin/FormWizardAddPostalSite"),
            },
            {
              name: "FormWizard",
              path: "FormWizard",
              component: () =>
                import("@/views/app/admin/FormWizard"),
            },
            {
              name: 'PaythingsReportsServices',
              path: 'paythingsreportsservices',
              component: () => import('@/views/app/admin/PaythingsReportsServices'),
            },
            {
              name: 'PaythingsInstitutionManagement',
              path: 'PaythingsInstitutionManagement',
              component: () => import('@/views/app/admin/PaythingsInstitutionManagement'),
            },
            {
              name: 'PaythingsReportsDevices',
              path: 'paythingsreportsdevices',
              component: () => import('@/views/app/admin//PaythingsReportsDevices'),
            },
            {
              name: 'PaythingsReportsCashLevels',
              path: 'paythingsreportscashlevels',
              component: () => import('@/views/app/admin/PaythingsReportsCashLevels'),
            },
            {
              name: 'PaythingsReportsHardware',
              path: 'paythingsreportshardware',
              component: () => import('@/views/app/admin/PaythingsReportsHardware'),
            },
            {
              name: 'PaythingsPostalManagement',
              path: 'PaythingsPostalManagement',
              component: () => import('@/views/app/admin/PaythingsPostalManagement'),
            },
            {
              path: 'safemanagement',
              name: 'safemanagement',
              component: () => import('@/views/app/admin/SafeManagement'),
            },
            {
              path: 'auditlog',
              name: 'auditlog',
              component: () => import('@/views/app/admin/AuditLog'),
            },
            {
              path: 'onboard',
              name: 'onboard',
              component: () => import('@/views/app/admin/OnboardSafe'),
            },
          ],
        },
      ],
    },

    {
      path: '/app/sessions',
      component: () => import('@/views/app/sessions/Sessions'),

      children: [
        {
          path: 'error',
          name: 'error',
          component: () => import('@/views/app/sessions/Error'),
        },
        {
          path: 'forgot',
          name: 'forgot',
          component: () => import('@/views/app/sessions/Forgot'),
        },
        {
          path: 'auth/:id',
          name: 'auth/:id',
          component: () => import('@/views/app/sessions/Auth'),
        },
        {
          path: 'sign-in',
          name: 'sign-in',
          component: () => import('@/views/app/sessions/SignIn'),
        },
        {
          path: 'sign-up',
          name: 'sign-up',
          component: () => import('@/views/app/sessions/SignUp'),
        },
        {
          path: 'reset',
          name: 'reset/:id',
          props: { default: true },
          component: () => import('@/views/app/sessions/Reset'),
        },
        {
          path: 'noaccess',
          name: 'noaccess',
          component: () => import('@/views/app/sessions/NoAccess'),
        },
        {
          path: 'logout',
          name: 'logout',
          component: () => import('@/views/app/sessions/Logout'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  console.log({ to, from })

  if (to.name === null) {
    console.log("DUNNO WHERE WE ARE GOING TO ")
    next({ path: '/app/sessions/sign-in' });
    console.log("DUNNO WHERE WE ARE GOING TO SIGN IN ")

    return
  }
  const userStatus = store.getters.user.status;
  console.log('^^^^^^^^ we have this user asking to nav ', store.getters.user)

  console.log('iniital load from no where ', store.getters.user)

  const perms = findPermissionsForRoute(items, to.name);
  console.log('perms ', perms)

  if (perms && !perms.includes(userStatus)) {
    console.log(perms, ' perms ', ' default to home ', userStatus)
    next({ path: '/' });
  }
  if (to.name.includes('auth')) {
    console.log('we included auth ', to.name, to, store.getters.user)
    next();
  }
  else {
    next();
  }
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  // setTimeout(() => store.dispatch('changeThemeLoadingState', false), 5000)
  // store.dispatch('changeThemeLoadingState', false)
})

export default router
